export const initializeSuperAdmin = () => {
  const users = JSON.parse(localStorage.getItem("users") || "[]");
  if (!users.some((user: any) => user.type === "super_admin")) {
    users.push({
      id: 1,
      name: "Super Admin",
      email: "admin@admin.com",
      password: "admin@123",
      type: "super_admin",
    });
    localStorage.setItem("users", JSON.stringify(users));
  }
};